import { Grid } from "@mui/material";
// import ProgressSteps from "../../components/ProgressSteps";
import WelcomeCard from "../../components/WelcomeCard";
import ProfileCard from "../../components/ProfileCard";
import CourseCareerSection from "../../components/CourseCareerSection";
// import StudentSuccessStories from "./SAP_Testimonial";
import DashboardStats from "./DashboardStats";
import DashboardTasks from "./DashboardTasks";
import { authFetch } from "../../../api";
import { useEffect, useState } from "react";

const SAPDashboard = () => {
  const userId = localStorage.getItem("userId");
  const [IsEnrolled, setIsEnrolled] = useState(false);

  const CheckEnrolled = async () => {
    try {
      const response = await authFetch(`packages/get-enrolled-packages`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user_id: userId }),
      });

      const data = await response.json();
      if (data?.data?.length > 0) {
        setIsEnrolled(true);
      } else {
        setIsEnrolled(false);
      }
      console.log("C", data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    CheckEnrolled();
  }, []);

  return (
    <Grid container spacing={2}>
      {/* Progress Steps Row */}
      {/* <Grid item xs={12}>
        <ProgressSteps />
      </Grid> */}

      <Grid
        item
        xs={12}
        container
        spacing={2}
        sx={{ display: "flex", alignItems: "stretch" }}
      >
        {/* Left Section */}
        <Grid
          item
          xs={12}
          md={8}
          lg={8}
          sx={{ display: "flex", flexDirection: "column", gap: 2 }}
        >
          {IsEnrolled ? (
            <>
              <DashboardStats />
              <DashboardTasks />
            </>
          ) : (
            <WelcomeCard />
          )}
          <CourseCareerSection />
          {/* <StudentSuccessStories /> */}
        </Grid>

        {/* Right Section */}
        <Grid item xs={12} md={4} lg={4}>
          <ProfileCard sx={{ flex: 1 }} />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SAPDashboard;
